(() => {
  const BBS_WHATSAPP_URL = 'https://wa.me/message/HVBZ6ZQLRRX2J1';

  const updateWhatsappLinks = (root, data) => {
    document.querySelectorAll('[data-bbs-whatsapp]').forEach((link) => {
      link.href = BBS_WHATSAPP_URL;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', `Contact us on WhatsApp about ${data.product || 'this product'}`);
    });
  };

  class BBSMainProduct {
    constructor(root) {
      this.root = root;
      this.product = JSON.parse(root.querySelector('[data-product-json]').textContent);
      this.selectedOptions = [...root.querySelectorAll('[data-option-group]')].map((group) => {
        const active = group.querySelector('[data-option-value].is-selected');
        return active ? active.dataset.optionValue : '';
      });
      this.variant = this.product.variants.find((item) => item.id === Number(root.dataset.initialVariant)) || this.product.variants[0];
      this.bindGallery();
      this.bindVariants();
      this.sync();
    }

    bindGallery() {
      this.root.querySelectorAll('[data-media-target]').forEach((button) => {
        button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget));
      });
    }

    showMedia(id) {
      this.root.querySelectorAll('[data-media-id]').forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === String(id)));
      this.root.querySelectorAll('[data-media-target]').forEach((button) => button.classList.toggle('is-active', button.dataset.mediaTarget === String(id)));
    }

    bindVariants() {
      this.root.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-option-group]');
          const position = Number(group.dataset.optionPosition) - 1;
          this.selectedOptions[position] = button.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('is-selected', item === button));
          const selectedText = group.querySelector('[data-option-selected]');
          if (selectedText) selectedText.textContent = button.dataset.optionValue;
          this.variant = this.product.variants.find((variant) => variant.options.every((value, index) => value === this.selectedOptions[index])) || this.variant;
          this.sync();
        });
      });
    }

    sync() {
      if (!this.variant) return;
      const sku = this.root.querySelector('[data-variant-sku]');
      if (sku) sku.textContent = this.variant.sku ? `SKU: ${this.variant.sku}` : '';
      const variantName = this.variant.public_title || this.variant.title || '';
      const price = this.root.querySelector('[data-variant-price]');
      if (price && this.variant.price != null) price.textContent = Shopify.formatMoney ? Shopify.formatMoney(this.variant.price) : (this.variant.price / 100).toFixed(2);
      const mediaId = this.variant.featured_media && this.variant.featured_media.id;
      if (mediaId) this.showMedia(mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.variant.id);
      window.history.replaceState({}, '', url.toString());
      updateWhatsappLinks(this.root, {
        base: this.root.dataset.whatsappBase,
        template: this.root.dataset.whatsappTemplate,
        product: this.product.title,
        variant: variantName,
        sku: this.variant.sku || ''
      });
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-bbs-main-product]:not([data-bbs-initialized])').forEach((root) => {
      root.dataset.bbsInitialized = 'true';
      new BBSMainProduct(root);
    });
    if (!scope.querySelector('[data-bbs-main-product]')) {
      const productName = document.querySelector('h1')?.textContent?.trim() || document.title;
      updateWhatsappLinks(scope, {
        base: document.querySelector('[data-bbs-whatsapp]')?.dataset.whatsappBase || '',
        template: document.querySelector('[data-bbs-whatsapp]')?.dataset.whatsappTemplate || 'Hello, I am interested in [product]. Product page: [url]',
        product: productName,
        variant: '',
        sku: ''
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
